import { useMemo } from "react";
import { useRequest } from "ahooks";
import { getScheduleTemplatesApi } from "@/apis/apiCollection";
import SingleSelector from "../SingleSelector";
import { useTranslation } from "@/langs/useTranslation";
import { uniqueObjectArray } from "@/helpers/utils";

const ScheduleTemplates = ({ disabled, name, value, onChange }) => {
  const { t } = useTranslation();

  const { data = [] } = useRequest(async () => {
    const res = await getScheduleTemplatesApi({
      status: 1,
      start: 0,
      length: 100000
    });
    return uniqueObjectArray(res.data, "schedule_template_id");
  });

  const options = useMemo(() => {
    return data.map(item => ({
      id: item.schedule_template_id,
      name: item.schedule_template_name
    }));
  }, [data]);

  const handleChange = e => {
    onChange?.(
      e,
      data.find(option => option.id === e.target.value)
    );
  };

  return (
    <SingleSelector
      placeholder={t({ defaultMessage: "选择模板" })}
      disabled={disabled}
      options={options}
      clearable
      style={{ width: 200 }}
      name={name}
      value={value}
      onChange={handleChange}
    />
  );
};

export default ScheduleTemplates;
